import React from "react";
import { List } from "../modules/Invoices/List";

export function InvoicesPage() {
  return <List />;
}
